/**
 * 利用サービスのモード
 */
export const SERVICE_MODE = {
  // ライブ通訳利用ユーザ
  LIVE: 'live',
  // Sentioユーザ
  SENTIO: 'sentio',
} as const;
export type ServiceMode = (typeof SERVICE_MODE)[keyof typeof SERVICE_MODE];

// マニュアルの遷移先のデータ型
export type ManualUrl = {
  default: string;
  [lang: string]: string;
};
